import { GetPolicyResponse } from '~/services/policy';

export interface AnalyticsPageView {
  event: AnalyticsStandardEvents.VirtualPageView;
  virtualPagePath: string;
  previousPath: string;
  virtualPageTitle: string;
  data?: object;
}

export interface AnalyticsStandard {
  event?: string;
  eventCategory?: string;
  eventAction: string;
  eventLabel?: string;
  nonInteraction?: boolean;
  data?: object;
}

export interface AnalyticsGoal {
  event:
    | GoalEvents.QuoteStart
    | GoalEvents.IndicativeQuote
    | GoalEvents.QuoteComplete
    | GoalEvents.Purchase
    | GoalEvents.PaymentEEC
    | GoalEvents.EmailQuote
    | GoalEvents.RetrieveQuote
    | GoalEvents.TransactionStart
    | GoalEvents.TransactionComplete;
  eventCategory: string;
  eventAction: string;
  eventLabel?: string;
  nonInteraction: boolean;
  data?: object;
}

export interface AnalyticsEcommerceEvent {
  event: GoalEvents.PaymentEEC;
  eventCategory: string;
  eventAction: string;
  eventLabel?: string;
  nonInteraction: boolean;
  data?: object;
  ecommerce: object;
}

export interface AnalyticsEcommerceGA4Event {
  event: GoalEvents.Purchase;
  data?: object;
  ecommerce: object;
}
export interface AnalyticsEngagement {
  event: AnalyticsStandardEvents.EngagementTracking;
  eventCategory: string;
  eventAction: string;
  eventLabel?: string;
  nonInteraction: boolean;
  data?: object;
}

export interface AnalyticsTiming {
  event: AnalyticsStandardEvents.Timing;
  timingCategory: string;
  timingValue: string;
  timingVar: string;
  timingLabel?: string;
  data?: object;
}

export interface AnalyticsRouteType {
  path: string;
}

export interface AnalyticsQuoteIdType {
  quoteStartId?: string;
  indicativeQuoteId?: string;
  quoteCompleteId?: string;
  buyCompleteId?: string;
  renewalPaymentId?: string;
}

export interface AnalyticsSessionTimeout {
  sessionExtended: number;
}

export interface AnalyticsRetrieveQuote {
  reachedPayment?: boolean;
  retrieveQuoteId?: string;
}

export interface Analytics {
  route: AnalyticsRouteType;
  goalIdentifiers: AnalyticsQuoteIdType;
  sessionTimeout: AnalyticsSessionTimeout;
  retrieveQuote: AnalyticsRetrieveQuote;
  payMyBill?: GetPolicyResponse;
}

export interface AnalyticsProducts {
  brand: string;
  category: string;
  variant?: unknown;
  quantity: number;
  name: string;
  price: number;
}

export interface AnalyticsEcommerceActionField {
  policyNumber: string;
  affiliation: string;
  revenue: number;
  coupon?: string;
}

export enum GoalEvents {
  QuoteStart = 'quote_start',
  IndicativeQuote = 'indicative_quote',
  QuoteComplete = 'quote_complete',
  Purchase = 'purchase',
  PaymentEEC = 'paymentEEC',
  RetrieveQuote = 'retrieve_quote',
  EmailQuote = 'email_quote',
  TransactionStart = 'transaction_start',
  TransactionComplete = 'transaction_complete',
}

export enum AnalyticsStandardEvents {
  VirtualPageView = 'virtualPageView',
  Standard = 'standard',
  Timing = 'timing',
  EngagementTracking = 'engagement_tracking',
  Optimize = 'optimize',
}

export enum AnalyticsTransactionType {
  renewalPayment = 'renewal payment',
}

export enum StreetTypes {
  alley = 'ally',
  arcade = 'arc',
  avenue = 'ave',
  boulevard = 'bvd',
  bypass = 'bypa',
  circuit = 'cct',
  close = 'cl',
  corner = 'crn',
  court = 'ct',
  crescent = 'cres',
  'cul-de-sac' = 'cds',
  drive = 'dr',
  esplanade = 'esp',
  green = 'grn',
  grove = 'gr',
  highway = 'hwy',
  junction = 'jnc',
  lane = 'lane',
  link = 'link',
  mews = 'mews',
  parade = 'pde',
  place = 'pl',
  ridge = 'rdge',
  road = 'rd',
  square = 'sq',
  street = 'st',
  terrace = 'tce',
  key = 'key',
}

export enum occupationSearchTypes {
  quickSearch = 'quickSearch',
  quickSearchSuccess = 'quickSearchSuccess',
  quickSearchNotFound = 'quickSearchNotFound',
  iconSearch = 'iconSearch',
}

export enum analyticsConstant {
  NOT_SET = '(not set)',
  API = 'api',
}
